
    import { AddToList, AddToListPlugin } from './add-to-list'
import { AliPayText, AliPayTextPlugin } from './ali-pay-text'
import { AliPay, AliPayPlugin } from './ali-pay'
import { ArrowBack, ArrowBackPlugin } from './arrow-back'
import { ArrowDown, ArrowDownPlugin } from './arrow-down'
import { ArrowLeft, ArrowLeftPlugin } from './arrow-left'
import { ArrowRadius, ArrowRadiusPlugin } from './arrow-radius'
import { ArrowRight, ArrowRightPlugin } from './arrow-right'
import { ArrowRough, ArrowRoughPlugin } from './arrow-rough'
import { ArrowUp, ArrowUpPlugin } from './arrow-up'
import { Ask, AskPlugin } from './ask'
import { Attachment, AttachmentPlugin } from './attachment'
import { Audit, AuditPlugin } from './audit'
import { Basket, BasketPlugin } from './basket'
import { Bottom, BottomPlugin } from './bottom'
import { BringForward, BringForwardPlugin } from './bring-forward'
import { BringFront, BringFrontPlugin } from './bring-front'
import { Building, BuildingPlugin } from './building'
import { Calculator, CalculatorPlugin } from './calculator'
import { CaretBottom, CaretBottomPlugin } from './caret-bottom'
import { CaretTop, CaretTopPlugin } from './caret-top'
import { CartFill, CartFillPlugin } from './cart-fill'
import { Cart, CartPlugin } from './cart'
import { CheckCircleLight, CheckCircleLightPlugin } from './check-circle-light'
import { Check, CheckPlugin } from './check'
import { ClockFill, ClockFillPlugin } from './clock-fill'
import { ClockLine, ClockLinePlugin } from './clock-line'
import { CloseBold, CloseBoldPlugin } from './close-bold'
import { CloseCircleFilled, CloseCircleFilledPlugin } from './close-circle-filled'
import { CloseCircleLight, CloseCircleLightPlugin } from './close-circle-light'
import { Close, ClosePlugin } from './close'
import { Comparison, ComparisonPlugin } from './comparison'
import { Cooperation, CooperationPlugin } from './cooperation'
import { CopySimple, CopySimplePlugin } from './copy-simple'
import { Copy, CopyPlugin } from './copy'
import { Custom, CustomPlugin } from './custom'
import { Date, DatePlugin } from './date'
import { Delete, DeletePlugin } from './delete'
import { Delivered, DeliveredPlugin } from './delivered'
import { Dialog, DialogPlugin } from './dialog'
import { DoubleList, DoubleListPlugin } from './double-list'
import { DownloadCircle, DownloadCirclePlugin } from './download-circle'
import { DownloadSimple, DownloadSimplePlugin } from './download-simple'
import { Download, DownloadPlugin } from './download'
import { Drag, DragPlugin } from './drag'
import { ElectronicManual, ElectronicManualPlugin } from './electronic-manual'
import { EmailFill, EmailFillPlugin } from './email-fill'
import { EmailLine, EmailLinePlugin } from './email-line'
import { Email, EmailPlugin } from './email'
import { Error, ErrorPlugin } from './error'
import { ExportList, ExportListPlugin } from './export-list'
import { Finished, FinishedPlugin } from './finished'
import { FollowFilled, FollowFilledPlugin } from './follow-filled'
import { Follow, FollowPlugin } from './follow'
import { FontBold, FontBoldPlugin } from './font-bold'
import { FontItalic, FontItalicPlugin } from './font-italic'
import { FontUnberline, FontUnberlinePlugin } from './font-unberline'
import { FullscreenExit, FullscreenExitPlugin } from './fullscreen-exit'
import { Fullscreen, FullscreenPlugin } from './fullscreen'
import { GoBack, GoBackPlugin } from './go-back'
import { GoTo, GoToPlugin } from './go-to'
import { Good, GoodPlugin } from './good'
import { Happy, HappyPlugin } from './happy'
import { Hot, HotPlugin } from './hot'
import { ImportList, ImportListPlugin } from './import-list'
import { InProcess, InProcessPlugin } from './in-process'
import { InProgress, InProgressPlugin } from './in-progress'
import { Info, InfoPlugin } from './info'
import { Inquiry, InquiryPlugin } from './inquiry'
import { Integral, IntegralPlugin } from './integral'
import { Invoice, InvoicePlugin } from './invoice'
import { Keyboard, KeyboardPlugin } from './keyboard'
import { LeftRightStructure, LeftRightStructurePlugin } from './left-right-structure'
import { List, ListPlugin } from './list'
import { Loading, LoadingPlugin } from './loading'
import { LocationInformation, LocationInformationPlugin } from './location-information'
import { Location, LocationPlugin } from './location'
import { Moment, MomentPlugin } from './moment'
import { Moon, MoonPlugin } from './moon'
import { More, MorePlugin } from './more'
import { Move, MovePlugin } from './move'
import { OneToOne, OneToOnePlugin } from './one-to-one'
import { OnlineEnquiry, OnlineEnquiryPlugin } from './online-enquiry'
import { OnlineOrder, OnlineOrderPlugin } from './online-order'
import { OrderCancel, OrderCancelPlugin } from './order-cancel'
import { OrderReport, OrderReportPlugin } from './order-report'
import { Ordered, OrderedPlugin } from './ordered'
import { OrganizeLine, OrganizeLinePlugin } from './organize-line'
import { Organize, OrganizePlugin } from './organize'
import { PaperManual, PaperManualPlugin } from './paper-manual'
import { PenEditDash, PenEditDashPlugin } from './pen-edit-dash'
import { PenEdit, PenEditPlugin } from './pen-edit'
import { Pen, PenPlugin } from './pen'
import { PendingPay, PendingPayPlugin } from './pending-pay'
import { Phone, PhonePlugin } from './phone'
import { PicDownload, PicDownloadPlugin } from './pic-download'
import { Pic, PicPlugin } from './pic'
import { PlusCircleFilled, PlusCircleFilledPlugin } from './plus-circle-filled'
import { PlusCircle, PlusCirclePlugin } from './plus-circle'
import { Plus, PlusPlugin } from './plus'
import { Print, PrintPlugin } from './print'
import { Qq, QqPlugin } from './qq'
import { Qrcode, QrcodePlugin } from './qrcode'
import { QuantityDiscount, QuantityDiscountPlugin } from './quantity-discount'
import { QuestionCircle, QuestionCirclePlugin } from './question-circle'
import { RadioDot, RadioDotPlugin } from './radio-dot'
import { Receiving, ReceivingPlugin } from './receiving'
import { Refresh, RefreshPlugin } from './refresh'
import { RegionFilled, RegionFilledPlugin } from './region-filled'
import { Right, RightPlugin } from './right'
import { Sad, SadPlugin } from './sad'
import { Saler, SalerPlugin } from './saler'
import { Save, SavePlugin } from './save'
import { Search, SearchPlugin } from './search'
import { Select, SelectPlugin } from './select'
import { SendBack, SendBackPlugin } from './send-back'
import { SendBackward, SendBackwardPlugin } from './send-backward'
import { Servers, ServersPlugin } from './servers'
import { Service, ServicePlugin } from './service'
import { Set, SetPlugin } from './set'
import { Setp, SetpPlugin } from './setp'
import { Share, SharePlugin } from './share'
import { ShoppingBag, ShoppingBagPlugin } from './shopping-bag'
import { SingleList, SingleListPlugin } from './single-list'
import { Star, StarPlugin } from './star'
import { Success, SuccessPlugin } from './success'
import { Sunny, SunnyPlugin } from './sunny'
import { Switch, SwitchPlugin } from './switch'
import { TelephoneFill, TelephoneFillPlugin } from './telephone-fill'
import { Telephone, TelephonePlugin } from './telephone'
import { ThreeDimensional, ThreeDimensionalPlugin } from './three-dimensional'
import { Tips, TipsPlugin } from './tips'
import { ToBeConfirmed, ToBeConfirmedPlugin } from './to-be-confirmed'
import { Tool, ToolPlugin } from './tool'
import { Top, TopPlugin } from './top'
import { UpDownStructure, UpDownStructurePlugin } from './up-down-structure'
import { UploadFile, UploadFilePlugin } from './upload-file'
import { UploadSimple, UploadSimplePlugin } from './upload-simple'
import { Upload, UploadPlugin } from './upload'
import { UserCircle, UserCirclePlugin } from './user-circle'
import { UserFilled, UserFilledPlugin } from './user-filled'
import { UserLeave, UserLeavePlugin } from './user-leave'
import { UserVerified, UserVerifiedPlugin } from './user-verified'
import { User, UserPlugin } from './user'
import { VideoLine, VideoLinePlugin } from './video-line'
import { View, ViewPlugin } from './view'
import { WaitDeliver, WaitDeliverPlugin } from './wait-deliver'
import { Warning, WarningPlugin } from './warning'
import { WechatLine, WechatLinePlugin } from './wechat-line'
import { WechatPayText, WechatPayTextPlugin } from './wechat-pay-text'
import { WechatPay, WechatPayPlugin } from './wechat-pay'
import { Wechat, WechatPlugin } from './wechat'
import { Weibo, WeiboPlugin } from './weibo'
import { WriteApplication, WriteApplicationPlugin } from './write-application'
import { Zhihu, ZhihuPlugin } from './zhihu'
import { ZoomIn, ZoomInPlugin } from './zoom-in'
import { ZoomOut, ZoomOutPlugin } from './zoom-out'
    export {AddToList,AliPayText,AliPay,ArrowBack,ArrowDown,ArrowLeft,ArrowRadius,ArrowRight,ArrowRough,ArrowUp,Ask,Attachment,Audit,Basket,Bottom,BringForward,BringFront,Building,Calculator,CaretBottom,CaretTop,CartFill,Cart,CheckCircleLight,Check,ClockFill,ClockLine,CloseBold,CloseCircleFilled,CloseCircleLight,Close,Comparison,Cooperation,CopySimple,Copy,Custom,Date,Delete,Delivered,Dialog,DoubleList,DownloadCircle,DownloadSimple,Download,Drag,ElectronicManual,EmailFill,EmailLine,Email,Error,ExportList,Finished,FollowFilled,Follow,FontBold,FontItalic,FontUnberline,FullscreenExit,Fullscreen,GoBack,GoTo,Good,Happy,Hot,ImportList,InProcess,InProgress,Info,Inquiry,Integral,Invoice,Keyboard,LeftRightStructure,List,Loading,LocationInformation,Location,Moment,Moon,More,Move,OneToOne,OnlineEnquiry,OnlineOrder,OrderCancel,OrderReport,Ordered,OrganizeLine,Organize,PaperManual,PenEditDash,PenEdit,Pen,PendingPay,Phone,PicDownload,Pic,PlusCircleFilled,PlusCircle,Plus,Print,Qq,Qrcode,QuantityDiscount,QuestionCircle,RadioDot,Receiving,Refresh,RegionFilled,Right,Sad,Saler,Save,Search,Select,SendBack,SendBackward,Servers,Service,Set,Setp,Share,ShoppingBag,SingleList,Star,Success,Sunny,Switch,TelephoneFill,Telephone,ThreeDimensional,Tips,ToBeConfirmed,Tool,Top,UpDownStructure,UploadFile,UploadSimple,Upload,UserCircle,UserFilled,UserLeave,UserVerified,User,VideoLine,View,WaitDeliver,Warning,WechatLine,WechatPayText,WechatPay,Wechat,Weibo,WriteApplication,Zhihu,ZoomIn,ZoomOut}
    export default [AddToListPlugin,AliPayTextPlugin,AliPayPlugin,ArrowBackPlugin,ArrowDownPlugin,ArrowLeftPlugin,ArrowRadiusPlugin,ArrowRightPlugin,ArrowRoughPlugin,ArrowUpPlugin,AskPlugin,AttachmentPlugin,AuditPlugin,BasketPlugin,BottomPlugin,BringForwardPlugin,BringFrontPlugin,BuildingPlugin,CalculatorPlugin,CaretBottomPlugin,CaretTopPlugin,CartFillPlugin,CartPlugin,CheckCircleLightPlugin,CheckPlugin,ClockFillPlugin,ClockLinePlugin,CloseBoldPlugin,CloseCircleFilledPlugin,CloseCircleLightPlugin,ClosePlugin,ComparisonPlugin,CooperationPlugin,CopySimplePlugin,CopyPlugin,CustomPlugin,DatePlugin,DeletePlugin,DeliveredPlugin,DialogPlugin,DoubleListPlugin,DownloadCirclePlugin,DownloadSimplePlugin,DownloadPlugin,DragPlugin,ElectronicManualPlugin,EmailFillPlugin,EmailLinePlugin,EmailPlugin,ErrorPlugin,ExportListPlugin,FinishedPlugin,FollowFilledPlugin,FollowPlugin,FontBoldPlugin,FontItalicPlugin,FontUnberlinePlugin,FullscreenExitPlugin,FullscreenPlugin,GoBackPlugin,GoToPlugin,GoodPlugin,HappyPlugin,HotPlugin,ImportListPlugin,InProcessPlugin,InProgressPlugin,InfoPlugin,InquiryPlugin,IntegralPlugin,InvoicePlugin,KeyboardPlugin,LeftRightStructurePlugin,ListPlugin,LoadingPlugin,LocationInformationPlugin,LocationPlugin,MomentPlugin,MoonPlugin,MorePlugin,MovePlugin,OneToOnePlugin,OnlineEnquiryPlugin,OnlineOrderPlugin,OrderCancelPlugin,OrderReportPlugin,OrderedPlugin,OrganizeLinePlugin,OrganizePlugin,PaperManualPlugin,PenEditDashPlugin,PenEditPlugin,PenPlugin,PendingPayPlugin,PhonePlugin,PicDownloadPlugin,PicPlugin,PlusCircleFilledPlugin,PlusCirclePlugin,PlusPlugin,PrintPlugin,QqPlugin,QrcodePlugin,QuantityDiscountPlugin,QuestionCirclePlugin,RadioDotPlugin,ReceivingPlugin,RefreshPlugin,RegionFilledPlugin,RightPlugin,SadPlugin,SalerPlugin,SavePlugin,SearchPlugin,SelectPlugin,SendBackPlugin,SendBackwardPlugin,ServersPlugin,ServicePlugin,SetPlugin,SetpPlugin,SharePlugin,ShoppingBagPlugin,SingleListPlugin,StarPlugin,SuccessPlugin,SunnyPlugin,SwitchPlugin,TelephoneFillPlugin,TelephonePlugin,ThreeDimensionalPlugin,TipsPlugin,ToBeConfirmedPlugin,ToolPlugin,TopPlugin,UpDownStructurePlugin,UploadFilePlugin,UploadSimplePlugin,UploadPlugin,UserCirclePlugin,UserFilledPlugin,UserLeavePlugin,UserVerifiedPlugin,UserPlugin,VideoLinePlugin,ViewPlugin,WaitDeliverPlugin,WarningPlugin,WechatLinePlugin,WechatPayTextPlugin,WechatPayPlugin,WechatPlugin,WeiboPlugin,WriteApplicationPlugin,ZhihuPlugin,ZoomInPlugin,ZoomOutPlugin]
    